import React, { Component } from "react";
import { Row, Col, Card, CardBody, Button, CardTitle } from "reactstrap";
import "bootstrap/dist/js/bootstrap.bundle";
import { Link } from "react-router-dom";
import AsyncSelect from "react-select/async";
import Select, { AriaOnFocus } from "react-select";
// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import { withTranslation } from "react-i18next";

import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { getLedgers, getPartyApi, getStockInward, updateLedgers } from "api";
import moment from "moment/moment";

class PartyWiseReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props,
      page: 1,
      sizePerPage: 10,
      totalSize: 10,
      ledgerList: [], 
      orderList: [], 
      partyList: [], 
      partyId: "",
      orderid: "",
      paymentStatus: "",
      props: props,
    };
  }

  async componentDidMount() {
    const jangadList = await await getStockInward({
      page: 1,
      limit: 10,
      paymentStatus:this.state.paymentStatus,
      orderId: this.state.orderId,
      partyId: this.state.partyId,
      paymentStatus: this.state.paymentStatus,
    });
    if(jangadList && jangadList.data){
      this.setState({
        orderList: jangadList.data.jangads,
      });
    }
    
    const partyList = await getPartyApi({
      page: null,
      limit: null,
      name: null,
      partyCode: null,
    });
    if (partyList && partyList.data && Array.isArray(partyList.data.parties)) {
      this.setState({ partyList: partyList.data.parties });
    }
    this.getStockList();
  }

  async getPartyList(inputValue) {
    const data = await getPartyApi({
      page: null,
      limit: null,
      name: null,
      partyCode: inputValue,
    });
    if(data && data.data){
      this.setState({
        partyList: data.data.parties,
      });
    }
   
    if (Array.isArray(data.data.parties))
      return [
        { label: "All", value: "" },
        ...data.data.parties.map(x => {
          return { label: x.name, value: x.id };
        }),
      ];
    else return [];
  }

  async getJangadList(inputValue) {
    const data = await getStockInward({
      page: 1,
      limit: 10,
      paymentStatus:this.state.paymentStatus,
      orderId: this.state.orderId,
      partyId: this.state.partyId,
      paymentStatus: this.state.paymentStatus,
      name: inputValue
    });
    if(data && data.data){
      this.setState({
        orderList: data.data.jangads,
      });
    }
   
    if (Array.isArray(data.data.jangads))
      return [
        { label: "All", value: "" },
        ...data.data.jangads.map(x => {
          return { label: x.mainJangad.id, value: x.mainJangad.id };
        }),
      ];
    else return [];
  }
  async getStockList() {
    const data = await getStockInward({
      page: this.state.page,
      limit: this.state.sizePerPage,
      paymentStatus:this.state.paymentStatus,
      orderId: this.state.orderId,
      partyId: this.state.partyId,
      paymentStatus: this.state.paymentStatus
    });
    if(data && data.data){
      this.setState({
        totalSize: data.data.count,
        ledgerList: data.data.jangads,
      });
    }
    
  }
  async update() {
    const data = await updateLedgers({
      id: this.state.props.data.id,
      approveStatus: this.state.approveStatus,
    });
  }

  render() {
    const promiseOptionsOrder = inputValue =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve(this.getJangadList(inputValue));
      }, 0);
    });
  const promiseOptions = inputValue =>
    new Promise(resolve => {
      setTimeout(() => {
        resolve(this.getPartyList(inputValue));
      }, 0);
    });
    this.columns1 = [
      {
        dataField: "as",
        text: `#`,
        sort: true,
        isDummyField: true,
        formatter: (cell, row, rowIndex) => {
          return rowIndex + 1;
        },
      },
      {
        dataField: "id",
        text: `${this.props.t("Sr.No.")}`,
        sort: true,
        hidden: true,
      },
      {
        dataField: "mainJangadId",
        text: `${this.props.t("Jangad Id")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.name;
        },
      },
      {
        dataField: "partyName",
        text: `${this.props.t("Party Name")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.party.name;
        },
      },
      {
        dataField: "pieces",
        style:{width:"120px"},
        text: `${this.props.t("Pieces")}`,
        sort: true,
        formatter(cell, row) {
          let tot = row?.dataEntryStock?.stockDataEntryInWards?.filter(x => x.ar).length;
          
          {
            return tot == row?.dataEntryStock?.stockDataEntryInWards?.length ? (
              <div className="d-flex justify-content-start pe-3">
                <div>{row.pieces}</div>
              </div>
            ) : (
              <div className="d-flex justify-content-between pe-3">
                <div>{row.pieces}</div>

                <div className="text-danger">({tot})</div>
              </div>
            );
          }
        },
      },
      {
        dataField: "weight",
        style:{width:"130px"},
        text: `${this.props.t("Weight")}`,
        sort: true,
        formatter(cell, row) {
          let tot = row?.dataEntryStock?.stockDataEntryInWards?.filter(x => x.ar)
            .reduce((acc, item) => acc + item.weight, 0)
            .toFixed(2);
          {
            return tot == row.weight ? (
              <div className="d-flex justify-content-start pe-3">
                <div>{row.weight}</div>
              </div>
            ) : (
              <div className="d-flex justify-content-between pe-3">
                <div>{row.weight}</div>

                <div className="text-danger">({tot})</div>
              </div>
            );
          }
        },
      },
      
      {
        dataField: "cycle",
        text: `${this.props.t("Cycle")}`,
        formatter(cell, row) {
          return row.cycle;
        },
      },
      {
        dataField: "createdAt",
        text: `${this.props.t("Inward Date")}`,
        formatter(cell, row) {
          return moment(row.createdAt).format("DD/MM/YYYY");
        },
        sort: true,
      },
      {
        dataField: "salesOfficeOutWardStock",
        text: `${this.props.t("OutWard Date")}`,
        formatter(cell, row) {
          if(cell == null) return "-"
          else 
          return moment(cell.createdAt).format("DD/MM/YYYY");
        },
        sort: true,
      },
      {
        dataField: "mainJangd",
        text: `${this.props.t("Payment Status")}`,
        sort: true,
        formatter: (cell, row) => {
          console.log(row.ledgerDetail);
          if (row.mainJangad.ledgerDetail == null) {
            return <></>;
          } else
          if (row.mainJangad.ledgerDetail.ledger.paymentStatus == "Paid") {
            return (
              <button className="btn-success-green border-0 py-2 px-3 rounded">
                Paid
              </button>
            );
          } else if (row.mainJangad.ledgerDetail.ledger.paymentStatus == "Pending") {
            return (
              <button className="btn-warning-yellow border-0 py-2 px-3 rounded">
                Pending
              </button>
            );
          } else if (row.mainJangad.ledgerDetail.ledger.paymentStatus == "Refund") {
            return (
              <button className="btn-danger-red border-0 py-2 px-3 rounded">
                Refund
              </button>
            );
          } else if (row.mainJangad.ledgerDetail.ledger.paymentStatus == "PartialPaid") {
            return (
              <button className="btn-primary-blue border-0 py-2 px-3 rounded">
                Partial Paid
              </button>
            );
          }
        },
      },
      {
        dataField: "viewdetail",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) =>
          row.weight == 0 ? (
            ""
          ) : (
            <>
              <div className="btn-group">
                <Link
                  to={{
                    pathname: "/party-wise-stock-view",
                    query: {
                      isEdit: 2,
                      data: row,
                    },
                  }}
                >
                  <button className="py-2 px-2 border-0 rounded">
                    <img src="images/dashboard-images/view.svg" />
                  </button>
                </Link>
              </div>
            </>
          ),
      },
    ];

    const defaultSorted = [
      {
        dataField: "id",
        order: "asc",
      },
    ];

    const pageOptions = {
      paginationSize: 5,
      pageStartIndex: 1,
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      onPageChange: (page, limit) => {
        this.setState({ page: page }, () => this.getStockList());
      },
      sizePerPageOptionRenderer: ({ text, page, onSizePerPageChange }) => {
        return (
          <li key={text} role="presentation" className="dropdown-item">
            <a
              href="#"
              className="text-dark"
              tabIndex="-1"
              role="menuitem"
              data-page={page}
              onMouseDown={e => {
                onSizePerPageChange(page);
                this.setState({ page: 1, sizePerPage: page }, () =>
                  this.getStockList()
                );
              }}
            >
              {text}
            </a>
          </li>
        );
      },
      sizePerPageList: [10, 25, 50, 100],
      page: this.state.page,
      totalSize: this.state.totalSize, // replace later with size(customers),
      custom: true,
    };

    const { SearchBar } = Search;

    const { history } = this.props;

    document.title = "admin-report";

    return (
      <PaginationProvider
        pagination={paginationFactory(pageOptions)}
        keyField="id"
        columns={this.columns1}
        data={this.state.ledgerList}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="id"
            columns={this.columns1}
            data={this.state.ledgerList}
            search
          >
            {toolkitProps => (
              <React.Fragment>
                <div className="page-content">
                  <div className="container-fluid">
                    <h3 className="text-black fw-bold text-uppercase">
                      {this.props.t("Party Wise Report")}
                    </h3>
                    <Row>
                      <Col className="col-12 mt-3">
                        <Card>
                          <CardBody>
                            <div className="d-xxl-flex d-block justify-content-between text-center text-xxl-start">
                              <div className="">
                                <h3 className="text-black fw-bold">
                                {this.props.t("Party Wise Report")}
                                </h3>
                              </div>

                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Select Party")}
                                    </label>
                                    <AsyncSelect
                                      id="partyId"
                                      className="officestock-select d-inline-block"
                                      onChange={e => {
                                        this.setState(
                                          {
                                            partyId: e.value,
                                            stockList: [],
                                            page: 1,
                                            sizePerPage: 10,
                                          },
                                          () => this.getStockList()
                                        );
                                      }}
                                      loadOptions={promiseOptions}
                                      defaultOptions={[
                                        { label: "All", value: "" },
                                        ...this.state.partyList.map(x => {
                                          return {
                                            value: x.id,
                                            label: x.name,
                                          };
                                        }),
                                      ]}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="d-xxl-flex d-block text-center text-xxl-start justify-content-between">
                              <div>
                                <div className="pt-3 pt-xxl-0">
                                  <p className="d-inline pe-3 fs-5">
                                    {this.props.t("Show")}
                                  </p>
                                  <div className="d-inline">
                                    <SizePerPageDropdownStandalone
                                      className=""
                                      {...paginationProps}
                                    />
                                  </div>
                                  <p className="d-inline ps-3 fs-5">
                                    {this.props.t("entries")}
                                  </p>
                                </div>
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Search Jangad")}
                                    </label>
                                    <AsyncSelect
                                      id="jangadId"
                                      className="officestock-select d-inline-block"
                                      onChange={e => {
                                        this.setState(
                                          {
                                            orderId: e.value,
                                            stockList: [],
                                            page: 1,
                                            sizePerPage: 10,
                                          },
                                          () => {
                                            if (e.value == "") {
                                              this.getJangadList(null);
                                            }
                                            this.getStockList();
                                          }
                                        );
                                      }}
                                      loadOptions={promiseOptionsOrder}
                                      defaultOptions={[
                                        { label: "All", value: "" },
                                        ...this.state.orderList.map(x => {
                                          return {
                                            label: x.mainJangad.name,
                                            value: x.mainJangad.id,
                                          };
                                        }),
                                      ]}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <label
                                  htmlFor="search"
                                  className="pt-2 fs-5 pe-1 pe-lg-3"
                                >
                                  {this.props.t("Payment Status")}
                                </label>

                                <Select
                                  onChange={e => {
                                    this.setState(
                                      {
                                        paymentStatus: e.value,
                                        stockList: [],
                                        page: 1,
                                        sizePerPage: 10,
                                      },
                                      () => {
                                        this.getStockList();
                                      }
                                    );
                                  }}
                                  aria-labelledby="aria-label"
                                  className="officestock-select d-inline-block"
                                  inputId="aria-example-input"
                                  name="aria-live-color"
                                  onMenuOpen={this.onMenuOpen}
                                  onMenuClose={this.onMenuClose}
                                  options={[
                                    { label: "All", value: "" },
                                    { label: "Paid", value: "Paid" },
                                    {
                                      label: "Pending",
                                      value: "Pending",
                                    },
                                    { label: "Refund", value: "Refund" },
                                    {
                                      label: "Partial Paid",
                                      value: "PartialPaid",
                                    },
                                  ]}
                                />
                              </div>
                            </div>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    remote={true}
                                    onTableChange={() => false}
                                    keyField={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                    <Col className="inner-custom-pagination mt-4 d-flex justify-content-between">
                      <div className="">
                        <h5>
                          {this.props.t("Showing")}{" "}
                          {(this.state.page - 1) * this.state.sizePerPage + 1} -{" "}
                          {this.state.totalSize < this.state.sizePerPage
                            ? this.state.totalSize
                            : this.state.sizePerPage * this.state.page >=
                              this.state.totalSize
                            ? this.state.totalSize
                            : this.state.sizePerPage * this.state.page}{" "}
                          of {this.state.totalSize}
                        </h5>
                      </div>
                      <div className="ms-auto">
                        <PaginationListStandalone {...paginationProps} />
                      </div>
                    </Col>
                  </div>
                </div>
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    );
  }
}

export default withTranslation()(PartyWiseReports);
